import { RouteObject } from 'react-router';

const checkoutRoutes: RouteObject[] = [
  {
    path: 'checkout',
    children: [
      {
        path: 'start-checkout/:ticketnummerOderKennzeichen',
        lazy: () => import('./page/checkout-page.tsx'),
      },
      {
        path: 'return/:ticketnummerOderKennzeichen',
        lazy: () => import('./page/return-page.tsx'),
      },
      {
        path: 'cancel/:ticketnummerOderKennzeichen',
        lazy: () => import('../ticket-ansicht/page/ticket-ansicht-page.tsx'),
      },
    ],
  },
];

export default checkoutRoutes;
